import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getAwardMetaSliceContent = createAsyncThunk('/awards/content', async () => {
	const response = await axios.post(`${API_URL}/getAwards`);
    console.log(response.data);
	return response;
})

export const awardSlice = createSlice({
    name: 'awards',
    initialState: {
        isLoading: false,
        awards : []
    },
    reducers: {
    },
    extraReducers: {
		[getAwardMetaSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getAwardMetaSliceContent.fulfilled]: (state, action) => {
			state.awards = action.payload.data
			state.isLoading = false
		},
		[getAwardMetaSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default awardSlice.reducer